var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types';
import { GuestAdjustmentService } from './guest-adjustment.service';
import { AppConfigService } from '../appConfig.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
var GuestAdjustmentComponent = /** @class */ (function () {
    function GuestAdjustmentComponent(toasterService, guestAdjustmentService, appConfigService, dialog) {
        this.toasterService = toasterService;
        this.guestAdjustmentService = guestAdjustmentService;
        this.appConfigService = appConfigService;
        this.dialog = dialog;
        this.adjustmentDone = new EventEmitter();
        this.disableSubmit = false;
        this.success = false;
        this.statusValue = [];
        this.creditReasons = [];
        this.debitReasons = [];
        this.maxCreditLimit = 0;
        this.maxDebitLimit = 0;
        this.info = {
            header: 'Customer Wallet Adjustment',
            headerClass: null,
            dataFetched: true,
            rows: []
        };
        this.roles = [];
        this.configLoaded = false;
    }
    GuestAdjustmentComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config, creditLimitMap, debitLimitMap, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.roles = this.accessCookie('Roles').split(',');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.appConfigService.getPoolOrdersAdjustmentConfig()];
                    case 2:
                        config = _a.sent();
                        creditLimitMap = config.creditLimit || {};
                        debitLimitMap = config.debitLimit || {};
                        this.creditReasons = config.credit_reasons ? JSON.parse(config.credit_reasons) : [];
                        this.debitReasons = config.debit_reasons ? JSON.parse(config.debit_reasons) : [];
                        this.maxCreditLimit = this.resolveLimit(creditLimitMap);
                        this.maxDebitLimit = this.resolveLimit(debitLimitMap);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error('Failed to load hopr adjustment config', e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.configLoaded = true;
                        this.buildActions();
                        return [2 /*return*/];
                }
            });
        });
    };
    GuestAdjustmentComponent.prototype.ngOnChanges = function (changes) {
        if (changes && changes.guestAdjDetails && changes.guestAdjDetails.currentValue) {
            if (!changes.guestAdjDetails.currentValue.dataFetched) {
                this.emptyCard('Cannot load adjustment');
                return;
            }
        }
        if (!this.configLoaded) {
            return;
        }
        this.buildActions();
    };
    GuestAdjustmentComponent.prototype.resolveLimit = function (limitMap) {
        var limits = this.roles
            .filter(function (role) { return limitMap[role] !== undefined; })
            .map(function (role) { return limitMap[role]; });
        return limits.length > 0 ? Math.max.apply(Math, limits) : 0;
    };
    GuestAdjustmentComponent.prototype.buildActions = function () {
        if (this.maxCreditLimit > 0) {
            if (!this.statusValue.includes('Credit')) {
                this.statusValue.push('Credit');
            }
        }
        if (this.maxDebitLimit > 0) {
            if (!this.statusValue.includes('Debit')) {
                this.statusValue.push('Debit');
            }
        }
        this.constructData();
    };
    GuestAdjustmentComponent.prototype.constructData = function () {
        if (this.statusValue.length > 0) {
            this.info = {
                header: 'Customer Wallet Adjustment',
                headerClass: null,
                dataFetched: true,
                rows: [
                    [
                        { titleClass: 'form-title-class', title: 'Action', type: 'single-searchable-dropdown',
                            values: this.statusValue, placeholder: 'Select action', key: 'hopr-guest-action',
                            default: undefined, className: 'col-md-6' },
                        { titleClass: 'form-title-class', title: 'Reason', type: 'single-searchable-dropdown',
                            values: [], placeholder: 'Select reason', key: 'hopr-guest-reason', className: 'col-md-6' }
                    ],
                    [
                        { titleClass: 'form-title-class', title: 'Amount', type: 'text-input',
                            placeholder: 'Enter Amount', key: 'hopr-guest-amount', className: 'col-md-6', numericOnly: true },
                        { titleClass: 'form-title-class', title: 'Wallet', type: 'single-searchable-dropdown',
                            values: ['Guest Wallet'], placeholder: 'Guest Wallet', key: 'hopr-guest-wallet',
                            className: 'col-md-6', default: 'Guest Wallet' }
                    ]
                ]
            };
        }
        else {
            this.info = {
                header: 'Customer Wallet Adjustment',
                accessDenied: true,
                dataFetched: true
            };
        }
    };
    GuestAdjustmentComponent.prototype.changeRows = function (event) {
        var reasons = event === 'Credit' ? this.creditReasons : this.debitReasons;
        if (event === 'Credit' || event === 'Debit') {
            this.info = {
                header: 'Customer Wallet Adjustment',
                headerClass: null,
                dataFetched: true,
                rows: [
                    [
                        { titleClass: 'form-title-class', title: 'Action', type: 'single-searchable-dropdown',
                            values: this.statusValue, placeholder: 'Select action', key: 'hopr-guest-action',
                            default: event, className: 'col-md-6' },
                        { titleClass: 'form-title-class', title: 'Reason', type: 'single-searchable-dropdown',
                            values: reasons, placeholder: 'Select reason', key: 'hopr-guest-reason', className: 'col-md-6' }
                    ],
                    [
                        { titleClass: 'form-title-class', title: 'Amount', type: 'text-input',
                            placeholder: 'Enter Amount', key: 'hopr-guest-amount', className: 'col-md-6', numericOnly: true },
                        { titleClass: 'form-title-class', title: 'Wallet', type: 'single-searchable-dropdown',
                            values: ['Guest Wallet'], placeholder: 'Guest Wallet', key: 'hopr-guest-wallet',
                            className: 'col-md-6', default: 'Guest Wallet' }
                    ]
                ]
            };
        }
    };
    GuestAdjustmentComponent.prototype.performAdjustment = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var action, reason, amount, maxLimit, userDetails, profileId, orderId, paymentRefId, dialogRef;
            var _this = this;
            return __generator(this, function (_a) {
                action = event['hopr-guest-action'];
                reason = event['hopr-guest-reason'];
                amount = Number(event['hopr-guest-amount']);
                if (!action) {
                    this.showWarning('Please select action');
                    return [2 /*return*/];
                }
                if (!reason) {
                    this.showWarning('Please select reason');
                    return [2 /*return*/];
                }
                if (!amount || amount <= 0) {
                    this.showWarning('Please enter a valid amount');
                    return [2 /*return*/];
                }
                if (!(parseFloat(event['hopr-guest-amount']) == event['hopr-guest-amount'])) {
                    this.showWarning('Please enter a valid number');
                    return [2 /*return*/];
                }
                maxLimit = action === 'Credit' ? this.maxCreditLimit : this.maxDebitLimit;
                if (amount > maxLimit) {
                    this.showWarning("You are allowed to " + action + " max Rs. " + maxLimit);
                    return [2 /*return*/];
                }
                userDetails = JSON.parse(this.accessCookie('user'));
                profileId = this.guestAdjDetails.profileId;
                orderId = this.guestAdjDetails.orderId;
                paymentRefId = this.generateUuid();
                dialogRef = this.dialog.open(ConfirmDialogComponent, {
                    width: '335px',
                    data: {
                        title: "Are you sure you want to " + action + "?",
                        type: 'order-details',
                        reason: action,
                        message: '',
                        buttonText: "Yes, " + action
                    }
                });
                dialogRef.afterClosed().subscribe(function (confirmed) {
                    if (!confirmed) {
                        return;
                    }
                    _this.disableSubmit = true;
                    var roles = _this.accessCookie('Roles').split(',');
                    var sharedBody = {
                        profileId: profileId,
                        channel: 'dashboard_order_adjustment',
                        amount: amount,
                        title: reason,
                        paymentRefId: paymentRefId,
                        orderId: orderId,
                        actorId: userDetails['_id'],
                        actorEmail: userDetails['emailId'],
                        actorRoles: roles,
                        ownerId: profileId,
                        ownerType: 'guest',
                        source: 'profiles-dashboard',
                        remarks: reason
                    };
                    if (action === 'Credit') {
                        _this.guestAdjustmentService.creditGuestWallet(sharedBody).subscribe(function () {
                            _this.showSuccess('Amount credited successfully');
                            _this.adjustmentDone.emit();
                            _this.disableSubmit = false;
                        }, function (err) {
                            _this.disableSubmit = false;
                            _this.showWarning(err && err.error && err.error.message || 'Unable to credit amount');
                        });
                    }
                    else {
                        _this.guestAdjustmentService.debitGuestWallet(sharedBody).subscribe(function () {
                            _this.showSuccess('Amount debited successfully');
                            _this.adjustmentDone.emit();
                            _this.disableSubmit = false;
                        }, function (err) {
                            _this.disableSubmit = false;
                            _this.showWarning(err && err.error && err.error.message || 'Unable to debit amount');
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    GuestAdjustmentComponent.prototype.showWarning = function (message) {
        this.toasterService.showToaster(new Toaster({ type: ToasterType.WARNING, message: message }));
    };
    GuestAdjustmentComponent.prototype.showSuccess = function (message) {
        this.toasterService.showToaster(new Toaster({ type: ToasterType.SUCCESS, message: message }));
        this.success = true;
    };
    GuestAdjustmentComponent.prototype.emptyCard = function (message) {
        this.info = {
            header: 'Customer Wallet Adjustment',
            dataFetched: false,
            emptyMessage: message || 'No data available'
        };
    };
    GuestAdjustmentComponent.prototype.generateUuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    GuestAdjustmentComponent.prototype.accessCookie = function (cookieName) {
        var name = cookieName + '=';
        var allCookieArray = document.cookie.split(';');
        for (var i = 0; i < allCookieArray.length; i++) {
            if (allCookieArray[i]) {
                var cookieItem = allCookieArray[i].trim();
                if (cookieItem.indexOf(name) === 0) {
                    return cookieItem.substring(name.length, cookieItem.length);
                }
            }
        }
        return '';
    };
    return GuestAdjustmentComponent;
}());
export { GuestAdjustmentComponent };
